import { userTypesList } from './constants';
import { log } from '../utility';

const outbrain = (userType) => {
  log('outbrain js');
  const isMobile = window.globals.isMobile;
  const isDesktop = !isMobile;
  const hasOutbrainDesktop =
    isDesktop && [userTypesList.ANONYMOUS, userTypesList.REGISTERED].includes(userType);
  const hasOutbrainMobile = isMobile && [userTypesList.ANONYMOUS].includes(userType);

  if (hasOutbrainDesktop || hasOutbrainMobile) {
    log('injecto outbrain per', userType);

    const tag = document.createElement('script');
    tag.type = 'text/javascript';
    tag.src = 'https://widgets.outbrain.com/outbrain.js';
    tag.async = 'async';
    const node = document.getElementsByTagName('script')[0];
    node.parentNode.insertBefore(tag, node);
  }
};

export default outbrain;
